module.exports = __webpack_public_path__ + "f33ce908a5fa64ed6112f7ddddaa8f8c.jpg";